/* eslint-disable @nx/enforce-module-boundaries */
import { HandShakeSimpleIcon } from '@mybridge/icons';
import { Box, HStack } from '@mybridge/ui/layout';
import { Link } from '@mybridge/ui/link';
import { Text } from '@mybridge/ui/text';
import { useContext, useMemo, useState } from 'react';
import { PostBoxContext } from '../context';
import { useRouter } from 'next/navigation';
import { InsightPopover } from '../insight-popover';
import { getUserFullName } from 'v4/lib/commons';
import _ from 'lodash';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { MyNetworkContext } from 'v4/components/network/context';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import { useDispatch, useSelector } from 'react-redux';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { getPostActivityUsers } from 'v4/store/actions/post.actions';
import { openGlobalPostModal } from 'v4/snippets/dashboard/global-post-container';
// import Link from "next/link"

export const PostBoxInsightPlate = ({
  maxCount = 15,
  handleCommentClicked,
  isReel,
  isSearch = false,
} = {}) => {
  const { push } = useRouter();
  const { t } = useTranslator();
  const { post, hasInsights, postModalLink, commentModal, setCommentModal } =
    useContext(PostBoxContext);
  const {
    comment_count,
    repost,
    like_count,
    dislike_count,
    share_count,
    // liked_by,
    // dislike_by,
    // reposts_by,
    // comment_by,
    visibility,
    author,
  } = post ?? {};
  const {formatNumber}=useNumberFormatter();
  const { loggedIn } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [liked_by, setLikedBy] = useState([]);
  const [dislike_by, setDislikeBy] = useState([]);
  const [comment_by, setCommentBy] = useState([]);
  const [reposts_by, setRepostsBy] = useState([]);
  const [reactionLoading, setReactionLoading] = useState(false);


  const likeDislikeCount = useMemo(() => {
    return (like_count ?? 0) + (dislike_count ?? 0);
  }, [like_count, dislike_count]);

  const likedBy = liked_by
    ?.filter?.((_, ind) => ind < maxCount)
    ?.map?.((lb, i) => (
      <Box key={i}>
        {lb?.author_type === 'COMPANY' ? lb?.company_detail?.name : getUserFullName(lb)}
      </Box>
    ));
  if (liked_by?.length > maxCount) {
    likedBy.push(<Box>{t('scheduling.and') || "and"} {liked_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
  }
  const dislikedBy = dislike_by
    ?.filter?.((_, ind) => ind < maxCount)
    ?.map?.((lb, i) => (
      <Box key={i}>
        {lb?.author_type === 'COMPANY' ? lb?.company_detail?.name : getUserFullName(lb)}
      </Box>
    ));
  if (dislike_by?.length > maxCount) {
    dislikedBy.push(<Box>{t('scheduling.and') || "and"} {dislike_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
  }
  const repostBy = _.uniqBy(reposts_by ?? [], (e) => e.id)
    ?.filter?.((_, ind) => ind < maxCount)
    .map?.((lb, i) => (
      <Box key={i}>
        {lb?.author_type === 'COMPANY' ? lb?.company_detail?.name : getUserFullName(lb)}
      </Box>
    ));
  if (reposts_by?.length > maxCount) {
    repostBy.push(<Box>{t('scheduling.and') || "and"} {reposts_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
  }

  const commentBy = comment_by
    ?.filter?.((_, ind) => ind < maxCount)
    ?.map?.((lb, i) => (
      <Box key={i}>
        {lb?.author_type === 'COMPANY' ? lb?.company_detail?.name : getUserFullName(lb)}
      </Box>
    ));
  if (comment_by?.length > maxCount) {
    commentBy.push(<Box>{t('scheduling.and') || "and"} {comment_by?.length - maxCount} {t('otherModules.more') || "more"}</Box>);
  }

  const { isFriend } = useContext(MyNetworkContext);
    // const isEventPostVisible = useMemo(() => {
    //   if (visibility === 2 || visibility === 1) {
    //     return isFriend(author);
    //   }
    //   return true;
    // }, [visibility, author, isFriend]);
  
    // if (!isEventPostVisible) {
    //   return null; // Don't render the event post if it's not visible
    // }

  const getReactionsUserData = (type='liked_by') => {
    const dataMap = {
      liked_by,
      disliked_by: dislike_by,
      commented_by: comment_by,
      shared_by: reposts_by,
    };
    // if(reactionLoading || dataMap?.[type]?.length > 0) return;
    setReactionLoading(true);
    dispatch(getPostActivityUsers({id: post?.id, type})).then((res)=>{
      const data = res?.payload?.results || [];
      switch(type) {
        case 'liked_by':
          setLikedBy(data);
          break;
        case 'disliked_by':
          setDislikeBy(data);
          break;
        case 'commented_by':
          setCommentBy(data);
          break;
        case 'shared_by':
          setRepostsBy(data);
          break;
        default:
          break;
      }
    }).finally(()=>{
      setReactionLoading(false);
    })
  }

  const handleMouseEnter = (type) => (e) => {
    e.stopPropagation();
    getReactionsUserData(type);
  };

  return (
    <>
      {hasInsights ? (
        <HStack px={4} py={2}>
          <HStack>
            <HStack spacing={0}>
              {like_count > 0 ? (
                <InsightPopover content={likedBy} reactionLoading={reactionLoading}>
                  <Box 
                  onMouseEnter={handleMouseEnter('liked_by')}                  
                  // onMouseEnter={handleMouseEnter}                  
                  // onMouseOver={handleMouseOver('liked_by')}                  
                  // onMouseOver={handleMouseOver}                  
                  // onClick={(e)=>{
                  //   e.stopPropagation();
                  //   getReactionsUserData("liked_by")
                  // }}
                  >
                    <HandShakeSimpleIcon width="14" height="14" color="green" />
                  </Box>
                </InsightPopover>
              ) : (
                ''
              )}
              {dislike_count > 0 ? (
                <InsightPopover content={dislikedBy} reactionLoading={reactionLoading}>
                  <Box 
                  onMouseEnter={handleMouseEnter('disliked_by')}
                  // onMouseOver={handleMouseOver('disliked_by')}
                  // onClick={(e)=>{
                  //   e.stopPropagation()
                  //   getReactionsUserData("disliked_by")
                  // }}
                  >
                    <HandShakeSimpleIcon width="14" height="14" color="red" />
                  </Box>
                </InsightPopover>
              ) : (
                ''
              )}
            </HStack>
            {likeDislikeCount > 0 ? (
              <Text color={isReel ? 'white' : 'brandGray.700'}>
                {formatNumber(likeDislikeCount)}
              </Text>
            ) : (
              ''
            )}
          </HStack>

          {/* need to discuss with sola */}
          <ForceSignInWrapper flex={1}>
            <HStack flex={1} justifyContent="flex-end">
              {comment_count > 0 ? (
                <InsightPopover content={commentBy} reactionLoading={reactionLoading}>
                  {isReel ? (
                    <Text
                      color={'white'}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCommentClicked();
                      }}
                    >
                      {`${formatNumber(comment_count)} ${
                        comment_count === 1 ? t('post.comment') || 'Comment' : t('post.comments') || 'Comments'
                      }`}
                    </Text>
                  ) : (
                    <Link
                      shallow={true}
                      onMouseEnter={handleMouseEnter('commented_by')}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        localStorage?.setItem('commentCLicked', true);
                        openGlobalPostModal({ post });
                      }}
                      // onMouseOver={handleMouseOver('commented_by')}
                      // onClick={(e) => {
                      //   e.stopPropagation();
                      //   getReactionsUserData("commented_by")
                      //   // localStorage?.setItem('commentCLicked', true);
                      // }}
                      // href={postModalLink(post?.id)}
                      href={`/post/${post?.id}`}
                      color={isReel ? 'white' : 'brandPrimary.500'}
                    >
                    {formatNumber(comment_count)} {/* Applied formatNumber */} {' '}
                      {comment_count === 1 ? t('post.comment') || 'Comment' : t('post.comments') || 'Comments'}
                    </Link>
                  )}
                </InsightPopover>
              ) : (
                ''
              )}
              {share_count > 0 ? (
                <InsightPopover content={repostBy} reactionLoading={reactionLoading}>
                  <Link color={isReel ? 'white' : 'brandPrimary.500'} 
                  onMouseEnter={handleMouseEnter('shared_by')}
                  // onMouseOver={handleMouseOver('shared_by')}
                  // onClick={(e)=>{
                  //   e.stopPropagation();
                  //   getReactionsUserData("shared_by")
                  // }}
                  >
                    {formatNumber(share_count)}  {repostBy.length < 2 ? t('post.share') || 'Share' : t('post.shares') || 'Shares'}
                  </Link>
                </InsightPopover>
              ) : (
                ''
              )}
            </HStack>
          </ForceSignInWrapper>
        </HStack>
      ) : (
         <Box minH="20px"></Box>
      )}
    </>
  );
};
